<!------------------------------------------------>
<!--            결제금액 계산 컴포넌트            -->
<!------------------------------------------------>
<template>
  <div :key="componentKey" v-if="done" class="payment-card">
    <div class="payment-card__inner">
      <div class="payment-card__header">
        <span class="payment-card__title">결제 정보</span>
      </div>
      <template v-if="isPromotion">
        <!-- 프로모션 요금제일 경우 -->
        <div class="payment-card__section">
          <div class="payment-card__label">적용된 프로모션 요금제</div>
          <div class="payment-card__value payment-card__value--primary">{{ paymentInfo.feeName }}</div>
        </div>
        <div class="payment-card__section">
          <div class="payment-card__label">사용 기간</div>
          <div class="payment-card__value">{{ paymentInfo.remark }}</div>
        </div>
        <div class="payment-card__section">
          <div class="payment-card__label">요금 합계</div>
          <div class="payment-card__detail">
            <div class="payment-card__row">{{ '프로모션 요금 : ' + formatToKoreanWon(paymentInfo.amountPerMonth) + '원' }}</div>
            <div class="payment-card__row">{{ 'VAT(10%) = ' + formatToKoreanWon(paymentInfo.amountPerMonth * 0.1) + '원' }}</div>
          </div>
        </div>
        <div class="payment-card__section payment-card__section--total">
          <div class="payment-card__label">총 금액(VAT 10% 포함)</div>
          <v-text-field
            class="payment-card__total-input editor_bg rounded right-input"
            :value="`${formatToKoreanWon(parseInt(paymentInfo.amountPerMonth) + parseInt(paymentInfo.amountPerMonth) * 0.1)}원`"
            readonly
            solo
            placeholder="총 금액(VAT 10% 포함)"
          />
        </div>
      </template>
      <template v-else>
        <!-- 일반 요금제일 경우 -->
        <div class="payment-card__section">
          <div class="payment-card__label">주문번호</div>
          <div class="payment-card__value">{{ `${paymentInfo.orderId}` }}</div>
        </div>
        <div class="payment-card__section">
          <div class="payment-card__label">적용된 요금제</div>
          <div class="payment-card__value">{{ `${paymentInfo.feeName} (월 ${formatToKoreanWon(paymentInfo.feeOriginAmount)}원)` }}</div>
        </div>
        <div v-if="paymentInfo.discountMethod" class="payment-card__section payment-card__section--discount">
          <div class="payment-card__label">적용된 할인</div>
          <div v-if="paymentInfo.discountMethod === '00001'" class="payment-card__value">
            {{ `${paymentInfo.discountName} (월 요금 ${formatToKoreanWon(paymentInfo.discountAmount)}원 할인)` }}
          </div>
          <div v-if="paymentInfo.discountMethod === '00002'" class="payment-card__value">
            {{ `${paymentInfo.discountName} (월 요금 ${paymentInfo.discountPercent}% 할인)` }}
          </div>
        </div>
        <template v-if="type === 'PAY'">
          <div class="payment-card__section">
            <div class="payment-card__label">사용 기간</div>
            <div class="payment-card__value">
              <div class="payment-card__value">{{ formatDate(paymentInfo.constructDtS) }}~{{ formatDate(paymentInfo.constructDtE) }}</div>
              <div class="payment-card__value">
                {{ (paymentInfo.useMonth > 0 ? paymentInfo.useMonth + '개월 ' : '') + (paymentInfo.useDay > 0 ? paymentInfo.useDay + '일' : '') }}
              </div>
            </div>
          </div>
          <div class="payment-card__section payment-card__section--breakdown">
            <div class="payment-card__label">요금 합계</div>
            <div class="payment-card__detail">
              <div class="payment-card__row d-flex align-center" v-if="paymentInfo.discountMethod === '00001'">
                <span class="payment-card__row-label">정액 할인:</span>
                <span class="payment-card__row-value">{{ `${formatToKoreanWon(paymentInfo.discountAmount)}원` }}</span>
              </div>
              <div class="payment-card__row d-flex align-center" v-else-if="paymentInfo.discountMethod === '00002'">
                <span class="payment-card__row-label">정률 할인:</span>
                <span class="payment-card__row-value">{{ `${paymentInfo.discountPercent}%` }}</span>
              </div>
              <div class="payment-card__row d-flex align-center">
                <span class="payment-card__row-label">월 단위 요금:</span>
                <span class="payment-card__row-value">{{ `${formatToKoreanWon(paymentInfo.amountPerMonth)}원` }}</span>
              </div>
              <div v-if="useDay > 0" class="payment-card__row d-flex align-center">
                <span class="payment-card__row-label">일 단위 요금:</span>
                <span class="payment-card__row-value">{{ `${formatToKoreanWon(paymentInfo.amountPerMonth)}원 / 30일` }}</span>
                <span class="payment-card__row-op">=</span>
                <span class="payment-card__row-value">{{ `${formatToKoreanWon(paymentInfo.amountPerDay)}원` }}</span>
              </div>
              <div class="payment-card__row d-flex align-center">
                <span class="payment-card__row-label">컨설팅 비용:</span>
                <span class="payment-card__row-value">{{ `${formatToKoreanWon(paymentInfo.extraAmount)}원 ` }}</span>
              </div>
              <div class="payment-card__row payment-card__row--sub">
                <span class="payment-card__row-label">결제 금액(VAT별도, 1자리 올림):</span>
              </div>
              <div class="payment-card__row d-flex align-center flex-wrap">
                <span v-if="paymentInfo.useMonth > 0" class="payment-card__row-value">{{
                  `${formatToKoreanWon(paymentInfo.amountPerMonth)}원 × ${paymentInfo.useMonth}개월`
                }}</span>
                <span v-if="paymentInfo.useMonth > 0 && paymentInfo.useDay > 0" class="payment-card__row-op">+</span>
                <span v-if="paymentInfo.useDay > 0" class="payment-card__row-value">{{
                  `${formatToKoreanWon(paymentInfo.amountPerDay)}원 × ${paymentInfo.useDay}일`
                }}</span>
                <span class="payment-card__row-op">+</span>
                <span class="payment-card__row-value">{{ `${formatToKoreanWon(paymentInfo.extraAmount)}원` }}</span>
                <span class="payment-card__row-op">=</span>
                <span class="payment-card__row-value payment-card__row-value--em">{{ `${formatToKoreanWon(paymentInfo.paymentAmount)}원` }}</span>
              </div>
              <div class="payment-card__row d-flex align-center">
                <span class="payment-card__row-label">VAT(10%):</span>
                <span class="payment-card__row-value">{{ `${formatToKoreanWon(paymentInfo.vat)}원` }}</span>
              </div>
            </div>
          </div>
          <div class="payment-card__section payment-card__section--total">
            <div class="payment-card__label">총 금액(VAT 10% 포함)</div>
            <v-text-field
              class="payment-card__total-input editor_bg rounded right-input"
              :value="`${formatToKoreanWon(paymentInfo.paymentAmount + paymentInfo.vat)}원`"
              readonly
              solo
              placeholder="총 금액(VAT 10% 포함)"
            />
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
// 컴포넌트
import baseview from '@/views/base/baseview.vue'
// api
import { getSojunganFeePaymentInfo } from '@/payment/api/sojunganFeeInfo.js'
import { getDiscountListByFee } from '@/api/feeManage/discountManage.js'
import { getPaymentInfo } from '@/api/sojunganManagement/constructManage'
// utils
import { getDateDiff } from '@/utils/common.js'
import { getCommonCode } from '@/api/common/commonApi'
//
export default {
  mixins: [baseview],
  components: {},
  name: 'calcPaymentAmount',
  props: {
    uniqueKey: {
      type: String,
      default: () => '', // 랜더링 키값
    },
    type: {
      type: String,
      default: () => 'PAY', // 금액 산출 기준 (PAY,CANCEL)
    },
    startDate: {
      type: String,
      default: () => '', // 사용기간 측정 기준이 되는 시작일
    },
    endDate: {
      type: String,
      default: () => '', // 사용기간 측정 기준이 되는 종료일
    },
    feeCd: {
      type: String,
      default: () => '', // 요금제 코드
    },
    isPromotion: {
      type: Boolean,
      default: () => false, // 프로모션 요금제 플래그값
    },
    propsData: {
      type: Object,
      default: () => {}, // 키 값
    },
  },
  data() {
    return {
      componentKey: 0,
      calcData: {},
      done: false,
      discountList: [],
      totalDiscountAmount: 0,
      totalDiscountPercent: 0,
      feeName: '',
      feeType: '',
      feeAmount: 0,
      useMonth: 0,
      useDay: 0,
      amountPerMonth: 0,
      amountPerDay: 0,
      totalAmount: 0,
      vat: 0,
      paymentAmount: 0,
      consultingAmount: 0,
      paymentInfo: {},
    }
  },
  watch: {
    uniqueKey: {
      immediate: true,
      handler(orderId) {
        if (orderId) {
          this.btnSearch()
        }
      },
    },
  },
  activated() {},
  created() {},
  mounted() {},
  methods: {
    formatDate(date) {
      if (!date) return null
      if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      }
      if (date.indexOf('.') > -1) {
        const [year, month, day] = date.split('.')
        return `${year}.${month}.${day}`
      }
      const year = date.substring(0, 4)
      const month = date.substring(4, 6)
      const day = date.substring(6, 8)
      return `${year}.${month}.${day}`
    },
    formatToKoreanWon(value) {
      if (value !== undefined && value !== null && value !== '') {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      }
      return '0'
    },
    btnSearch() {
      console.log('#### call calcPayemntAmount', this.propsData)
      this.done = false
      this.calcData = {}

      let param = {
        clntId: this.propsData.clntId,
        compId: this.propsData.compId,
        writeDt: this.propsData.writeDt,
        docNo: this.propsData.docNo,
        orderId: this.propsData.orderId,
      }
      
      getPaymentInfo(param, true).then((res) => {
        console.log('## 결제 정보 :: ', res)
        this.paymentInfo = res
        this.done = true
      })

      // getSojunganFeePaymentInfo({ feeCd: this.feeCd })
      //   .then(res => {
      //     this.calcData = res
      //   })
      //   .finally(async () => {
      //     this.feeType = this.calcData.feeType

      //     // FEE003 코드 가져오기
      //     const commonCodeRes = await getCommonCode('FEE003')
      //     const match = commonCodeRes.list.find(item => item.minorCd === this.feeType)

      //     // 요금제 타입에 따른 consultingAmount 설정
      //     this.consultingAmount = match ? match.extra1 : 0

      //     getDiscountListByFee({ feeCd: this.feeCd })
      //       .then(res => {
      //         if (res.success) {
      //           this.discountList = res.list
      //         }
      //       })
      //       .finally(() => {
      //         let calcAmount = this.calcData.feeAmount
      //         this.feeAmount = this.calcData.feeAmount
      //         this.feeName = this.calcData.feeName
      //         this.totalDiscountAmount = 0
      //         this.totalDiscountPercent = 0
      //         // 할인 총량 계산
      //         this.discountList.forEach(dis => {
      //           if (dis.method == '00001') {
      //             this.totalDiscountAmount += dis.discountAmount
      //           }
      //           if (dis.method == '00002') {
      //             this.totalDiscountPercent += dis.discountPercent
      //           }
      //         })

      //         // 할인 총량 반영 : 1자리 올림 처리
      //         calcAmount = calcAmount - this.totalDiscountAmount
      //         calcAmount = Math.ceil((calcAmount * (100 - this.totalDiscountPercent)) / 100 / 10) * 10
      //         this.amountPerMonth = calcAmount
      //         this.amountPerDay = Math.ceil(this.amountPerMonth / 30)

      //         let startDate = this.startDate
      //         let endDate = this.endDate
      //         console.log('@@@@ ', this.startDate, this.endDate)
      //         if (this.type === 'PAY') {
      //           // 결제 금액 산출
      //           let useDuration = getDateDiff(startDate, endDate) // 사용 종료일 23:59 - 사용 시작일로 계산한다.
      //           this.useMonth = useDuration.month
      //           this.useDay = useDuration.date
      //           this.totalAmount =
      //             Math.ceil((Number(this.amountPerMonth) * Number(this.useMonth) + Number(this.amountPerDay) * Number(this.useDay)) / 10) * 10 +
      //             Number(this.consultingAmount)

      //           this.vat = Number(this.totalAmount) * 0.1

      //           this.paymentAmount = this.totalAmount + this.vat
      //         }
      //         /*
      //         else if (this.type === 'CANCEL') {
      //           // 환불 금액 산출
      //           let remainDuration = getDateDiff(startDate, endDate)
      //           this.calcData.remainMonth = remainDuration.month
      //           this.calcData.remainDay = remainDuration.date

      //           // 남은 기간과 요금에 따른 월/일 별 요금
      //           this.calcData.totalRefundAmount =
      //             Math.ceil((this.calcData.amountPerMonth * this.calcData.remainMonth + this.calcData.amountPerDay * this.calcData.remainDay) / 10) *
      //             10
      //           this.calcData.refundVat = this.calcData.totalRefundAmount * 0.1
      //           this.calcData.refundAmount = this.calcData.totalRefundAmount + this.calcData.refundVat
      //         }
      //         */
      //         // this.componentKey++
      //         this.done = true
      //       })
      //   })
    },
  },
}
</script>
<style scoped>
.payment-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

.payment-card__inner {
  padding: 0;
}

.payment-card__header {
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  color: #fff;
}

.payment-card__title {
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.payment-card__section {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.payment-card__section:last-child {
  border-bottom: none;
}

.payment-card__section--total {
  background: #f8fafc;
  padding: 18px 20px;
}

.payment-card__section--discount {
  background: #fefdf8;
}

.payment-card__section--breakdown {
  background: #fafbfc;
}

.payment-card__label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.payment-card__value {
  font-size: 0.9375rem;
  color: #1e293b;
  line-height: 1.5;
}

.payment-card__value--primary {
  font-weight: 600;
  color: #0f172a;
}

.payment-card__detail {
  margin-top: 4px;
}

.payment-card__row {
  padding: 6px 0;
  font-size: 0.875rem;
  color: #334155;
  line-height: 1.5;
}

.payment-card__row--sub {
  padding-top: 10px;
  margin-top: 4px;
  border-top: 1px dashed #e2e8f0;
}

.payment-card__row-label {
  margin-right: 10px;
  color: #64748b;
}

.payment-card__row-value {
  color: #1e293b;
  font-weight: 500;
}

.payment-card__row-value--em {
  font-weight: 700;
  color: #0f172a;
}

.payment-card__row-op {
  margin: 0 6px;
  color: #94a3b8;
  font-weight: 500;
}

.payment-card__total-input >>> .v-input__slot {
  background: #fff !important;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.payment-card__total-input >>> input {
  text-align: right;
  font-size: 1.125rem !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.right-input >>> input {
  text-align: right;
}
</style>
